module.exports = __webpack_public_path__ + "static/bosses_icon-3f4909a3ae08127bc4614fee36172531.png";